exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3fuewdnIfE2XKBQy97b8vo{font-size:16px}._3u3GRcO8NSbdqx7EbDXQ2S,._3fuewdnIfE2XKBQy97b8vo{color:\"[theme:neutralSecondary, default:#666666]\"}._3u3GRcO8NSbdqx7EbDXQ2S{font-size:24px}", ""]);
// Exports
exports.locals = {
	"iconSmall": "_3fuewdnIfE2XKBQy97b8vo",
	"icon": "_3u3GRcO8NSbdqx7EbDXQ2S"
};